export default {
    LoadGroupsInLeftNavFromSessionData: {
        name: 'LoadGroupsInLeftNavFromSessionData',
        options: {
            // isQos disables sampling
            isQos: true,
        },
    },
};
